import React, { useEffect, useRef, useState } from "react";

import AnttButton from "../../../vendors/components/Button";
import { faEye, faPencil } from "@fortawesome/free-solid-svg-icons";

import "./assets/index.scss";
import If from "../../../vendors/components/If";
import { useHistory } from "react-router-dom";
import InnerHtml from "../inner-html";
import Tabs from "../tabs";
import EventoContribuicaoFormController from "../../pages/DefaultPage/Evento/controller/evento-contribuicao-form.controller";

// Adicionar no topo do arquivo, após os imports
interface AnexoContribuicao {
  cdSeqAnexoContribuicao: number;
  codContribuicao: number;
  dsAnexo: string;
  dsCaminhoAnexo: string;
  noAnexo: string;
  dtCadastro: string;
  stPublicado: boolean;
  stSigiloso: boolean;
  codContribuicaoNavigation: any;
}

interface Props {
  value: any;
  evento: any;
  rollBackUrl: any;
  idEvento?: any;
  controller: any;
  nomeAnexo?: any;
  podeEditar?: boolean;
}

export default function ContribuicaoItem({
  value,
  evento,
  rollBackUrl,
  idEvento,
  controller,
  podeEditar,
}: Props) {
  const [show, setShow] = useState(false);
  const [descricaoAnexo, setDescricaoAnexo] = useState<string>("");
  const [anexos, setAnexos] = useState<AnexoContribuicao[]>([]);
  const history = useHistory();

  const controllerContribuicao = useRef(
    new EventoContribuicaoFormController()
  ).current;

  const outrosMeios = evento.dsDispositivo == "ContribuicaoOutrosMeios";
  const [carregouAnexo, setCarregouAnexo] = useState(false);

  useEffect(() => {
    if (!show && !outrosMeios) return;
    if (carregouAnexo) return;

    async function carregarAnexo() {
      try {
        const anexo: AnexoContribuicao[] =
          await controllerContribuicao.obterAnexoContribuicaoByCodContribuicao(
            value.codContribuicao
          );

        if (anexo && Array.isArray(anexo) && anexo.length > 0) {
          setAnexos(anexo);
          setDescricaoAnexo(anexo[0].dsAnexo || anexo[0].noAnexo || "");
        } else {
          setAnexos([]);
          setDescricaoAnexo("");
        }
      } catch (error) {
        console.error("Erro ao carregar anexo:", error);
        setAnexos([]);
        setDescricaoAnexo("");
      } finally {
        setCarregouAnexo(true);
      }
    }
    carregarAnexo();
  }, [value.codContribuicao, controllerContribuicao, show, outrosMeios, carregouAnexo]);

  const formattedValue =
    value.dsContribuicao?.replace(/<\/?[^>]+(>|$)/g, "") ?? "";
  const user = controller.getUser();
  // const sigiloso = value.dsContribuicaoSigilosa != null || value.anexoContribuicao;
  const contribuiu = !!user &&
    !!user.contribuinte &&
    user.contribuinte.codContribuinte == value.codContribuinte;

  function sigiloso(){
    if(value.dsContribuicaoSigilosa != null || value.anexoContribuicao.find((x: any) => x.stSigiloso == true)){
      return true;
    }
    return false;
  };

  return (
    <>
      <div className="dispositivo-wrapper">
        <If condition={formattedValue.length > 25}>
          <div
            onClick={() => setShow(!show)}
            className="dispostivo-item-wrapper"
          >
            <i className={`pi ${show ? "pi-angle-up" : "pi-angle-down"}`} />
            <label>{formattedValue.substring(0, 25)}...</label>
          </div>
        </If>
        <If condition={formattedValue.length <= 25}>
          <label>
            <If condition={outrosMeios}>
              <If
                condition={
                  evento.dsDispositivo == "ContribuicaoOutrosMeios" &&
                  value.dsContribuicao == null
                }
              >
                <InnerHtml
                  value={`${value.noUsuarioCadastro} - ${descricaoAnexo}`}
                />
              </If>
              <If condition={value.dsContribuicao != null}>
                <InnerHtml value={value.dsContribuicao} />
              </If>
            </If>
            <If condition={!outrosMeios}>
              {/* <If condition={sigiloso()}> */}
                <InnerHtml value={sigiloso() ? value.dsContribuicaoSigilosa : value.dsContribuicao}/>
              {/* </If> */}
            </If>
          </label>
        </If>
        <div className="dispositivo-acoes">
          <AnttButton
            onClick={() => {
              const isEventoInterno = sessionStorage.getItem('idEventoInterno') != null;
              const route = isEventoInterno ? "/evento-interno-contribuicao" : "/evento/contribuicao";
              history.push(route, {
                id: value.codDispositivo,
                codContribuicao: value.codContribuicao,
                isView: true,
                rollBackUrl,
                idEvento,
                nomeAnexo: descricaoAnexo,
              });
            }}
            faIcon={faEye}
            tooltip="Visualizar contribuição"
            tooltipOptions={{ position: "left" }}
            className="p-button-rounded p-button-rounded-info"
          />
          <If condition={!!podeEditar}>
            <AnttButton
              onClick={() => {
                const isEventoInterno = sessionStorage.getItem('idEventoInterno') != null;
                const route = isEventoInterno ? "/evento-interno-contribuicao" : "/evento/contribuicao";
                history.push(route, {
                  id: value.codDispositivo,
                  codContribuicao: value.codContribuicao,
                  codAudienciaPublica: evento.codAudienciaPublica,
                  isView: false,
                  isEdit: true,
                  rollBackUrl,
                  idEvento: evento.codAudienciaPublica,
                  nomeAnexo: descricaoAnexo,
                });
              }}
              faIcon={faPencil}
              tooltip="Editar contribuição"
              tooltipOptions={{ position: "left" }}
              className="p-button-rounded p-button-rounded-info"
            />
          </If>
        </div>
      </div>
      {show && (
        <p style={{ padding: "10px" }}>
          <InnerHtml value={sigiloso() ? value.dsContribuicaoSigilosa : value.dsContribuicao} />
          {descricaoAnexo && (
            <div>
              <strong>Anexo:</strong> {descricaoAnexo}
            </div>
          )}
        </p>
      )}
    </>
  );
}
